export class SigninFormComponent {
    constructor(root, param = {}) {
        Object.assign(this, {
            param,
        });
        this.$root = $(root);
        this.id = this.$root.attr('id');
        this.parentControl = param.controlerName;

        this.$btn = this.$root.find('button[type="submit"]');
        this.$credentialsError = this.$root.find('[data-wrong-credentials]');
        this.$inputs = this.$root.find('.m-input');
        this.onSubmit = this.onSubmit.bind(this);

        this._setHandlers();
    }

    resetFields() {
        // Enable to reset the modal in case of errors, when we close the modal.
        if (this.$credentialsError) {
            this.$credentialsError.attr('visible', 'false');
            this.$credentialsError.attr('no-html-error-text', '');
        }
        this.$inputs.each((idx, el) => {
            $(el).removeClass('invalid');
        });
    }

    done() {
        this.$credentialsError.attr('visible', 'false');
        setTimeout(() => {
            this.param.successCallback ? this.param.successCallback() : Hop.connect.control.popupClosed(false);
        }, 100);
    }

    fail(errorMessage) {
        if (this.$credentialsError) {
            this.$credentialsError.attr('visible', 'true');
            this.$credentialsError.attr('no-html-error-text', errorMessage);
        }

        this.$btn.removeAttr('disabled');

        this.$inputs.each((idx, el) => {
            $(el).addClass('invalid');
        });
    }

    sendData() {
        this.$btn.attr('disabled', true);

        $.post('/api/account/signin', {
            email: this.$root.find('[name=email]').val(),
            password: this.$root.find('[name=password]').val(),
        })
            .done(() => {
                this.done();
            })
            .fail((jqXHR) => {
                this.fail(jqXHR.responseText);
            });
    }

    onSubmit(event) {
        event.preventDefault();
        this.sendData();
    }

    _setHandlers() {
        this.$root.on('submit', this.onSubmit);
    }

    destroy() {
        this.$root.off('submit', this.onSubmit);
        this.resetFields();
    }
}
